import { ReactNode } from 'react';

interface Props {
  leftArea?: ReactNode;
  rightArea?: ReactNode;
  className?: string;
}

export const ListHeader = ({ leftArea, rightArea, className }: Props) => (
  <div className={`${className} flex flex-row justify-between w-full px-4 py-0`}>
    <div className="flex flex-row self-start justify-center">{leftArea}</div>
    <div className="flex flex-row items-center gap-2">{rightArea}</div>
  </div>
);

export const SectionText = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={`${className} flex flex-row items-center gap-2 h-[56px] font-bold text-lg`}>{children}</div>
);
